import { COMPARISON_OPERATORS } from '@witmetrics/utils/constants';
import { buildColumnFilter } from '@witmetrics/utils/filters';

export const PAGE_SIZE = 20;

export const IS_READ_FILTER = buildColumnFilter(
  'isRead',
  COMPARISON_OPERATORS.IS.value,
  false
);
